export enum AgeGroupType {
  ALL = "all",
  YOUNGEST = "youngest",
  YOUNG = "young",
  MEDIUM = "medium",
  OLD = "old",
  OLDEST = "oldest",
}

export const AgeGroupLabel = {
  [AgeGroupType.ALL]: "Alle Altersgruppen",
  [AgeGroupType.YOUNGEST]: "Altersgruppe bis 25 Jahre",
  [AgeGroupType.YOUNG]: "Altersgruppe 26 - 35 Jahre",
  [AgeGroupType.MEDIUM]: "Altersgruppe 36 - 50 Jahre",
  [AgeGroupType.OLD]: "Altersgruppe 51 - 65 Jahre",
  [AgeGroupType.OLDEST]: "Altersgruppe über 65 Jahre",
};



// WEBPACK FOOTER //
// ./src/types/AgeGroupType.tsx